import { render, staticRenderFns } from "./POItemsList.vue?vue&type=template&id=11621c6c&"
import script from "./POItemsList.vue?vue&type=script&lang=js&"
export * from "./POItemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports